import { css } from "@emotion/react";

import { Colors, SkeletonBlock } from "@zapier/design-system";

const reloaderStyle = css`
  border-radius: 1.5px;
  overflow: hidden;
  position: absolute;
  top: -23px;
  width: 100%;

  div {
    background-color: transparent;
  }

  div:before {
    background-image: linear-gradient(
      90deg,
      transparent,
      ${Colors.UiPrimaryStronger},
      transparent
    );
  }
`;

function Reloader() {
  return (
    <div css={reloaderStyle}>
      <SkeletonBlock height={3} />
    </div>
  );
}

export default Reloader;
